import type { ArrowPressHandler } from "@noriginmedia/norigin-spatial-navigation";
import { actionLocationNavigate, locationAtom } from "@sunrise/location";
import { playerCurrentEpgItemAtom } from "@sunrise/player";
import { useAtomValue, useSetAtom } from "jotai";
import { type ReactElement, useCallback } from "react";

import { FocusIconButton } from "@/components/buttons/focus-icon-button/focus-icon-button";
import { route } from "@/config/route";
import * as styles from "@/features/player-controls/player-controls.css";

type InfoButtonProps = {
  focusKey: string;
  onArrowPress: ArrowPressHandler;
};

export function InfoButton({
  focusKey,
  onArrowPress,
}: InfoButtonProps): ReactElement {
  const dispatchLocation = useSetAtom(locationAtom);
  const epgEntry = useAtomValue(playerCurrentEpgItemAtom);
  const disabled = !epgEntry;
  const onEnterPress = useCallback(() => {
    if (!epgEntry) return;

    dispatchLocation(
      actionLocationNavigate(
        route.details.root({
          epgId: epgEntry.id,
          assetId: epgEntry.asset.id,
        }),
      ),
    );
  }, [epgEntry, dispatchLocation]);

  return (
    <FocusIconButton
      key="info"
      focusKey={focusKey}
      data-testid="player-controls.button.info"
      className={styles.button}
      iconName="info"
      disabled={disabled}
      onEnterPress={onEnterPress}
      onArrowPress={onArrowPress}
    />
  );
}
